export const initialState = {
  firstName: '',
  lastName: '',
  teacher: '',
  errorMessage: "We couldn't find your student. Please enter your student's teacher and grade.",
  submissionFail: false,
  dateOfBirth: undefined,
  grade: undefined,
  student: undefined,
};

export const UPDATE_VALUE = 'UPDATE_VALUE';

export const reducer = (state, action) => {

  switch(action.type) {
    case UPDATE_VALUE:
      return { ...state, [action.payload.key]: action.payload.value };
    default:
      throw new Error();
  }
};
